import * as TYPES from "./Timeline.types";
import { updateChapterStep } from "../../utils";

export const initialState = {
  timeline: {},
  chapters: [],
  chapterStep: null,
  currentSlide: {},
  currentChapter: {},
  loading: false,
  error: false,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.FETCH_TIMELINE: {
      return {
        ...state,
        loading: true,
      };
    }
    case TYPES.FETCH_TIMELINE_FAIL: {
      return {
        ...state,
        error: true,
        loading: false,
      };
    }
    case TYPES.FETCH_TIMELINE_SUCCESS: {
      return {
        ...state,
        timeline: action?.result,
        chapters: action?.result?.chapters,
        loading: false,
      };
    }
    case TYPES.SET_CHAPTER_STEP: {
      return {
        ...state,
        loading: true,
      };
    }
    case TYPES.SET_CHAPTER_STEP_SUCCESS: {
      return {
        ...state,
        loading: false,
        chapterStep: action.result,
      };
    }
    case TYPES.SET_CHAPTER_STEP_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case TYPES.SET_CURRENT_CHAPTER: {
      return {
        ...state,
        loading: true,
      };
    }
    case TYPES.SET_CURRENT_CHAPTER_SUCCESS: {
      return {
        ...state,
        loading: false,
        currentChapter: action.result,
      };
    }
    case TYPES.SET_CURRENT_CHAPTER_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }

    case TYPES.SET_CHAPTER_SLIDE_STEP: {
      return {
        ...state,
        loading: true,
      };
    }
    case TYPES.SET_CHAPTER_SLIDE_STEP_SUCCESS: {
      return {
        ...state,
        loading: false,
        chapters: updateChapterStep(
          state.chapters,
          state.currentChapter,
          action.result
        ),
        currentChapter: {
          ...state.currentChapter,
          step: action.result,
        },
      };
    }
    case TYPES.SET_CHAPTER_SLIDE_STEP_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }

    default:
      return state;
  }
};

export default reducer;
